/**
 * Collapse consecutive tool-call rows that share a `batchId` into groups.
 * Missing / empty ids stay singletons so we never invent a batch from a
 * flat raw_response snapshot that has no grouping signal.
 */
export function groupConsecutiveByBatchId<T extends { batchId?: string }>(items: T[]): T[][] {
  const groups: T[][] = []
  for (const item of items) {
    const last = groups[groups.length - 1]
    const id = item.batchId
    if (id !== undefined && id.length > 0 && last !== undefined && last[0]?.batchId === id) {
      last.push(item)
      continue
    }
    groups.push([item])
  }
  return groups
}

export interface ToolBatchSummary {
  calls: number
  /** Number of groups — i.e. how many tool-calling turns the agent spent. */
  turns: number
}

/** Headline numbers for the debug tool log. */
export function summarizeToolBatches(calls: { batchId?: string }[]): ToolBatchSummary {
  return {
    calls: calls.length,
    turns: groupConsecutiveByBatchId(calls).length
  }
}
